/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: RegisterForm.tsx
 * Project: mle-client
 * Committed last: 2021/11/2 @ 177
 * ---
 */

import { Form, Formik }           from 'formik';
import React                      from 'react';
import * as Yup                   from 'yup';
import { defaultRequiredMessage } from '../../config/content';
import { Button }                 from '@blueprintjs/core';
import { BpTextFieldWrapper }     from './wrappers/BpTextFieldWrapper';
import { DefaultFormProps }       from '../../common/interfaces';

const RegisterFormValidationSchema = Yup.object().shape({
  password1: Yup.string().required(defaultRequiredMessage),
  password2: Yup.string().required(defaultRequiredMessage),
});

export interface ResetPasswordFormValues {
  password1: string;
  password2: string;
}

export const ResetPasswordForm = (props: DefaultFormProps) => {
  return (
    <Formik
      initialValues={ {} as ResetPasswordFormValues }
      validationSchema={ RegisterFormValidationSchema }
      onSubmit={ props.onSubmit }
    >
      { ({}) => (
        <Form>
          <div className="mle-form-row"></div>
          <BpTextFieldWrapper name="password1" label="Password" type="password"
                              required/>
          <BpTextFieldWrapper name="password2" label="Conferma password"
                              type="password"
                              required/>
          <div className="mle-form-submit">
            <Button intent="primary" type="submit" className="w-full">
              Reimposta password
            </Button>
          </div>
        </Form>
      ) }
    </Formik>
  );
};
